<template>
  <div class="animated fadeIn">
    <c-card>
      <c-card-header>
        <c-icon name="cil-circle" />
        Base spinners
        <div class="card-header-actions">
          <a
            href="https://coreui.io/vue/docs/components/spinner.html"
            rel="noopener noreferrer"
            target="_blank"
            class="card-header-action"
          >
            <small class="text-muted">docs</small>
          </a>
        </div>
      </c-card-header>
      <c-card-body>
        <div class="d-flex justify-content-between align-items-center">
          <c-spinner color="success" size="sm" />
          <c-spinner color="info" />
          <c-spinner color="primary" style="width:4rem;height:4rem;" />

          <c-spinner grow size="sm" />
          <c-spinner color="warning" grow />
          <c-spinner style="width:4rem;height:4rem;" color="danger" grow />
        </div>
      </c-card-body>
    </c-card>
    <c-card>
      <c-card-header>
        <c-icon name="cil-circle" />
        Spinners - SpinKit
        <a href="https://coreui.io/pro/vue/" rel="noreferrer noopener" target="_blank" class="badge badge-danger ml-1">
          CoreUI Pro
        </a>
        <div class="card-header-actions">
          <a
            href="https://github.com/tobiasahlin/SpinKit"
            rel="noopener noreferrer"
            target="_blank"
            class="card-header-action"
          >
            <small class="text-muted">docs</small>
          </a>
        </div>
      </c-card-header>
      <c-card-body>
        <p>
          Simple loading spinners animated with CSS. SpinKit uses hardware accelerated (translate and opacity) CSS
          animations to create smooth and easily customizable animations.
        </p>
      </c-card-body>
    </c-card>
    <c-row>
      <c-col xl="3" lg="4" md="6">
        <c-card>
          <c-card-header>
            Rotating plane
          </c-card-header>
          <c-card-body>
            <div class="sk-plane" />
          </c-card-body>
        </c-card>
      </c-col>
      <c-col xl="3" lg="4" md="6">
        <c-card>
          <c-card-header>
            Double bounce
          </c-card-header>
          <c-card-body>
            <div class="sk-bounce">
              <div class="sk-bounce-dot" />
              <div class="sk-bounce-dot" />
            </div>
          </c-card-body>
        </c-card>
      </c-col>
      <c-col xl="3" lg="4" md="6">
        <c-card>
          <c-card-header>
            Wave
          </c-card-header>
          <c-card-body>
            <div class="sk-wave">
              <div class="sk-wave-rect" />
              <div class="sk-wave-rect" />
              <div class="sk-wave-rect" />
              <div class="sk-wave-rect" />
              <div class="sk-wave-rect" />
            </div>
          </c-card-body>
        </c-card>
      </c-col>
      <c-col xl="3" lg="4" md="6">
        <c-card>
          <c-card-header>
            Wandering cubes
          </c-card-header>
          <c-card-body>
            <div class="sk-wander">
              <div class="sk-wander-cube" />
              <div class="sk-wander-cube" />
            </div>
          </c-card-body>
        </c-card>
      </c-col>
      <c-col xl="3" lg="4" md="6">
        <c-card>
          <c-card-header>
            Pulse
          </c-card-header>
          <c-card-body>
            <div class="sk-pulse" />
          </c-card-body>
        </c-card>
      </c-col>
      <c-col xl="3" lg="4" md="6">
        <c-card>
          <c-card-header>
            Chasing dots
          </c-card-header>
          <c-card-body>
            <div class="sk-chase">
              <div class="sk-chase-dot" />
              <div class="sk-chase-dot" />
              <div class="sk-chase-dot" />
              <div class="sk-chase-dot" />
              <div class="sk-chase-dot" />
              <div class="sk-chase-dot" />
            </div>
          </c-card-body>
        </c-card>
      </c-col>
      <c-col xl="3" lg="4" md="6">
        <c-card>
          <c-card-header>
            Swing
          </c-card-header>
          <c-card-body>
            <div class="sk-swing">
              <div class="sk-swing-dot" />
              <div class="sk-swing-dot" />
            </div>
          </c-card-body>
        </c-card>
      </c-col>
      <c-col xl="3" lg="4" md="6">
        <c-card>
          <c-card-header>
            Flow
          </c-card-header>
          <c-card-body>
            <div class="sk-flow">
              <div class="sk-flow-dot" />
              <div class="sk-flow-dot" />
              <div class="sk-flow-dot" />
            </div>
          </c-card-body>
        </c-card>
      </c-col>
      <c-col xl="3" lg="4" md="6">
        <c-card>
          <c-card-header>
            Circle
          </c-card-header>
          <c-card-body>
            <div class="sk-circle">
              <div class="sk-circle-dot" />
              <div class="sk-circle-dot" />
              <div class="sk-circle-dot" />
              <div class="sk-circle-dot" />
              <div class="sk-circle-dot" />
              <div class="sk-circle-dot" />
              <div class="sk-circle-dot" />
              <div class="sk-circle-dot" />
              <div class="sk-circle-dot" />
              <div class="sk-circle-dot" />
              <div class="sk-circle-dot" />
              <div class="sk-circle-dot" />
            </div>
          </c-card-body>
        </c-card>
      </c-col>
      <c-col xl="3" lg="4" md="6">
        <c-card>
          <c-card-header>
            Cube grid
          </c-card-header>
          <c-card-body>
            <div class="sk-grid">
              <div class="sk-grid-cube" />
              <div class="sk-grid-cube" />
              <div class="sk-grid-cube" />
              <div class="sk-grid-cube" />
              <div class="sk-grid-cube" />
              <div class="sk-grid-cube" />
              <div class="sk-grid-cube" />
              <div class="sk-grid-cube" />
              <div class="sk-grid-cube" />
            </div>
          </c-card-body>
        </c-card>
      </c-col>
      <c-col xl="3" lg="4" md="6">
        <c-card>
          <c-card-header>
            Fading circle
          </c-card-header>
          <c-card-body>
            <div class="sk-circle-fade">
              <div class="sk-circle-fade-dot" />
              <div class="sk-circle-fade-dot" />
              <div class="sk-circle-fade-dot" />
              <div class="sk-circle-fade-dot" />
              <div class="sk-circle-fade-dot" />
              <div class="sk-circle-fade-dot" />
              <div class="sk-circle-fade-dot" />
              <div class="sk-circle-fade-dot" />
              <div class="sk-circle-fade-dot" />
              <div class="sk-circle-fade-dot" />
              <div class="sk-circle-fade-dot" />
              <div class="sk-circle-fade-dot" />
            </div>
          </c-card-body>
        </c-card>
      </c-col>
      <c-col xl="3" lg="4" md="6">
        <c-card>
          <c-card-header>
            Folding Cube
          </c-card-header>
          <c-card-body>
            <div class="sk-fold">
              <div class="sk-fold-cube" />
              <div class="sk-fold-cube" />
              <div class="sk-fold-cube" />
              <div class="sk-fold-cube" />
            </div>
          </c-card-body>
        </c-card>
      </c-col>
    </c-row>
  </div>
</template>

<script>
export default {
  name: 'Spinners',
};
</script>

<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.card-body div {
  margin: auto;
}
</style>
